import { Link, Outlet, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "./context/AppContext";
import "./Css/dashboard.css";

// Dashboard component to manage the admin dashboard layout
const Dashboard = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  const { isLoggedIn } = useContext(AppContext);
  return (
    <div
      // style={{ display: "flex", minHeight: "100vh" }}
      className="dashborard_main"
    >
      {isLoggedIn && (
        <aside className="sidebar_main">
          <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
            Dashboard
          </h2>

          <>
            <Link to="gamelist" style={linkStyle(isActive("/gamelist"))}>
              Game List
            </Link>
            <Link to="addCategory" style={linkStyle(isActive("/addCategory"))}>
              Add Category
            </Link>
            {/* <Link to="saveuser" style={linkStyle(isActive('/saveuser'))}>Add User</Link> */}

            <Link to="createmenu" style={linkStyle(isActive("/createmenu"))}>
              Create Menu
            </Link>
          </>
          <Link to="blog" style={linkStyle(isActive("/blog"))}>
            Blog
          </Link>
          <Link to="register" style={linkStyle(isActive("/register"))}>
            Register
          </Link>
          <Link to="addvertise" style={linkStyle(isActive("/register"))}>
            Advertise
          </Link>
          <Link to="login" style={linkStyle(isActive("/saveuser"))}>
            Login
          </Link>
        </aside>
      )}

      <main style={{ flexGrow: 1 }}>
        {/* <div>
          <h1>Welcome to the Admin Dashboard</h1>
        <p>Select an option from the sidebar to manage your application.</p>
        </div> */}
        <Outlet />
      </main>
    </div>
  );
};

const linkStyle = (active) => ({
  color: active ? "#00d8ff" : "#fff",
  textDecoration: "none",
  fontWeight: active ? "bold" : "normal",
  marginBottom: "12px",
});

export default Dashboard;
